export const ROOT = 'StepPayment/formPayment/ruc';

export const FETCH_RUC_REQUEST = `${ROOT}/FETCH_RUC_REQUEST`;
export const FETCH_RUC_FAILURE = `${ROOT}/FETCH_RUC_FAILURE`;
export const FETCH_RUC_SUCCESS = `${ROOT}/FETCH_RUC_SUCCESS`;

export const CREATE_RUC_REQUEST = `${ROOT}/CREATE_RUC_REQUEST`;
export const CREATE_RUC_FAILURE = `${ROOT}/CREATE_RUC_FAILURE`;
export const CREATE_RUC_SUCCESS = `${ROOT}/CREATE_RUC_SUCCESS`;

export const UPDATE_RUC_REQUEST = `${ROOT}/UPDATE_RUC_REQUEST`;
export const UPDATE_RUC_FAILURE = `${ROOT}/UPDATE_RUC_FAILURE`;
export const UPDATE_RUC_SUCCESS = `${ROOT}/UPDATE_RUC_SUCCESS`;

export const SET_DISABLED_RUC_INPUTS = `${ROOT}/DISABLED_RUC_INPUTS`;
export const CLEAR_RUC_DATA = `${ROOT}/CLEAR_RUC_DATA`;
